import React from "react";
import { Show } from "./components/Show";
import { Track } from "./components/Track";
import { Playlist } from "./components/Playlist";
import { Episode } from "./components/Episode";
import { Album } from "./components/Album";
export var SpotifyEmbed = function (_a) {
    var type = _a.type, _b = _a.variant, variant = _b === void 0 ? "default" : _b, title = _a.title, url = _a.url, className = _a.className;
    if (type === "Show") {
        return React.createElement(Show, { url: url, title: title, variant: variant });
    }
    if (type === "Track") {
        return React.createElement(Track, { url: url, title: title, variant: variant });
    }
    if (type === "Playlist") {
        return React.createElement(Playlist, { url: url, title: title, variant: variant });
    }
    if (type === "Episode") {
        return React.createElement(Episode, { url: url, title: title, variant: variant });
    }
    if (type === "Album") {
        return React.createElement(Album, { url: url, title: title, variant: variant });
    }
    return React.createElement("div", { className: className }, "No valid Spotify type given");
};
